import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-brand-bg" data-id="element-122">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.15)_0%,rgba(10,14,23,1)_70%)] pointer-events-none" data-id="element-123" />

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-124">
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-8" data-id="element-125">
          <div className="space-y-4" data-id="element-126">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-gold leading-tight tracking-tight drop-shadow-lg" data-id="element-127">
              Si estás perdiendo dinero en apuestas…
            </h1>
            <h2 className="text-xl md:text-2xl text-brand-text font-medium leading-relaxed max-w-2xl" data-id="element-128">
              Deja de depender de tipsters, grupos de Telegram y picks que no
              funcionan. Aprende a analizar fútbol como un profesional y toma el
              control de tus apuestas.
            </h2>
          </div>

          <div className="w-full max-w-md lg:max-w-none space-y-4" data-id="element-129">
            <CTAButton className="w-full lg:w-auto animate-pulse-slow" data-id="element-130">
              👉 QUIERO DEJAR DE PERDER DINERO
            </CTAButton>
            <div className="flex items-center justify-center lg:justify-start gap-2 text-brand-muted text-sm" data-id="element-131">
              <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-132" />
              <span data-id="element-133">
                ✔ Acceso inmediato ✔ Método paso a paso ✔ Sin experiencia
                previa
              </span>
            </div>
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end" data-id="element-134">
          <div className="relative w-full max-w-lg aspect-square rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,168,67,0.2)] border border-brand-gold/20" data-id="element-135">
            <img src="https://cdn.magicpatterns.com/uploads/nGDmaB74Jcw9sMkZbvZa9V/Metodo_2B_bonus_1x1.png" alt="Portada El Método Sin-Tipster" className="w-full h-full object-contain" data-id="element-136" />
          </div>
        </div>
      </div>
    </section>;
}